var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bw",attrs:{"id":"app"}},[_c('navbar'),_c('div',{staticClass:"container-fluid",staticStyle:{"margin-top":"100px"}},[_c('div',{},[_c('router-view')],1)]),_c('footer-panel'),_c('cookie-notice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }